// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_dropdown__kyreG {
  position: relative;
  width: 100%;
}

.styles_dropdownTrigger__zEYAQ {
  padding: 10px 12px;
  width: 100%;
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  background-color: var(--color-white);
  color: var(--color-black);
  font: var(--typography-body-m-regular);
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
}
.styles_dropdownTrigger__zEYAQ:hover {
  border-color: var(--color-strokes-blue);
  background-color: white;
}

.styles_dropdownValue__BStsP {
  flex: 1 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.styles_dropdownPlaceholder__L7dUQ {
  color: var(--color-text-secondary);
}

.styles_dropdownArrow__H6pZO {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}
.styles_dropdownArrow__H6pZO img {
  width: 24px;
  height: 24px;
  transition: transform 0.2s ease;
}

.styles_dropdownOpen__\\+IB4j .styles_dropdownArrow__H6pZO img {
  transform: rotate(180deg);
}

.styles_dropdownList__wvX1f {
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-height: 350px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.styles_searchContainer__dqaI9 {
  padding: 8px;
  border-bottom: 1px solid var(--color-gray-strokes);
}

.styles_searchInput__qOSbX {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-gray-strokes);
  border-radius: 8px;
  font: var(--typography-body-m-regular);
  outline: none;
  transition: border-color 0.2s ease;
}
.styles_searchInput__qOSbX:focus {
  border-color: var(--color-strokes-blue);
}
.styles_searchInput__qOSbX::placeholder {
  color: var(--color-text-secondary);
}

.styles_optionsList__cLUQ\\+ {
  overflow-y: auto;
  max-height: 280px;
  padding: 4px;
}
.styles_optionsList__cLUQ\\+::-webkit-scrollbar {
  width: 8px;
}
.styles_optionsList__cLUQ\\+::-webkit-scrollbar-thumb {
  background: var(--color-gray-strokes);
  border-radius: 4px;
}
.styles_optionsList__cLUQ\\+::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-secondary);
}

.styles_dropdownOption__yE3tS {
  padding: 10px 12px;
  width: 100%;
  min-height: 44px;
  border: none;
  border-radius: 8px;
  background-color: var(--color-white);
  color: var(--color-black);
  font: var(--typography-body-m-regular);
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  text-align: left;
  outline: none;
}
.styles_dropdownOption__yE3tS:hover {
  background-color: var(--color-bg-light-blue);
}
.styles_dropdownOption__yE3tS.styles_dropdownOptionSelected__tOwhE {
  background-color: var(--color-blue-light);
  color: var(--color-black);
}

.styles_otherOption__t2xjN {
  border-top: 1px solid var(--color-gray-strokes);
  margin-top: 4px;
  padding-top: 12px;
  color: var(--color-text-secondary);
  font-style: italic;
}
.styles_otherOption__t2xjN:hover {
  color: var(--color-black);
}

.styles_loadingState__YfsB8,
.styles_emptyState__Kl\\+4R,
.styles_hintState__K69Qo {
  padding: 16px;
  text-align: center;
  color: var(--color-text-secondary);
  font: var(--typography-body-s-regular);
}

.styles_dropdownError__kfLj1 .styles_dropdownTrigger__zEYAQ {
  border-color: var(--color-error);
}
.styles_dropdownError__kfLj1 .styles_dropdownTrigger__zEYAQ:hover, .styles_dropdownError__kfLj1 .styles_dropdownTrigger__zEYAQ:focus {
  background-color: var(--color-white);
  border-color: var(--color-error);
  box-shadow: 0 0 0 3px rgba(206, 32, 33, 0.1);
}

.styles_dropdownDisabled__\\+XtSp .styles_dropdownTrigger__zEYAQ {
  background-color: #f5f5f5;
  color: #999;
  border-color: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.6;
}
.styles_dropdownDisabled__\\+XtSp .styles_dropdownTrigger__zEYAQ:hover, .styles_dropdownDisabled__\\+XtSp .styles_dropdownTrigger__zEYAQ:focus {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
  box-shadow: none;
}

.styles_dropdownDisabled__\\+XtSp .styles_dropdownArrow__H6pZO img {
  opacity: 0.5;
}

/* Custom school input styles */
.styles_customInputContainer__93DRC {
  padding: 16px;
}

.styles_customInputLabel__2jg3z {
  margin: 0 0 12px 0;
  font: var(--typography-body-m-medium);
  color: var(--color-black);
}

.styles_customInput__IJS2q {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-gray-strokes);
  border-radius: 8px;
  font: var(--typography-body-m-regular);
  outline: none;
  transition: border-color 0.2s ease;
  margin-bottom: 12px;
}
.styles_customInput__IJS2q:focus {
  border-color: var(--color-strokes-blue);
}
.styles_customInput__IJS2q::placeholder {
  color: var(--color-text-secondary);
}

.styles_customInputActions__jE21A {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.styles_customInputCancel__agMTA,
.styles_customInputSubmit__dcL54 {
  padding: 8px 16px;
  border-radius: 8px;
  font: var(--typography-body-s-medium);
  cursor: pointer;
  transition: all 0.2s ease;
}

.styles_customInputCancel__agMTA {
  background-color: transparent;
  border: 1px solid var(--color-gray-strokes);
  color: var(--color-text-secondary);
}
.styles_customInputCancel__agMTA:hover {
  background-color: var(--color-bg-light-blue);
  border-color: var(--color-strokes-blue);
  color: var(--color-black);
}

.styles_customInputSubmit__dcL54 {
  background-color: var(--color-primary);
  border: none;
  color: var(--color-white);
}
.styles_customInputSubmit__dcL54:hover:not(:disabled) {
  background-color: var(--color-primary-hover);
}
.styles_customInputSubmit__dcL54:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/school-dropdown/styles.module.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,2CAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAAF;AAEE;EACE,uCAAA;EACA,uBAAA;AAAJ;;AAIA;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AADF;;AAIA;EACE,kCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AADJ;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,YAAA;EACA,kDAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,kCAAA;AAFF;AAIE;EACE,uCAAA;AAFJ;AAKE;EACE,kCAAA;AAHJ;;AAOA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;AAJF;AAME;EACE,UAAA;AAJJ;AAOE;EACE,qCAAA;EACA,kBAAA;AALJ;AAOI;EACE,uCAAA;AALN;;AAUA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAPF;AASE;EACE,4CAAA;AAPJ;AAUE;EACE,yCAAA;EACA,yBAAA;AARJ;;AAYA;EACE,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;AATF;AAWE;EACE,yBAAA;AATJ;;AAaA;;;EAGE,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,sCAAA;AAVF;;AAaA;EACE,gCAAA;AAVF;AAYE;EAEE,oCAAA;EACA,gCAAA;EACA,4CAAA;AAXJ;;AAeA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAZF;AAcE;EAEE,yBAAA;EACA,qBAAA;EACA,gBAAA;AAbJ;;AAiBA;EACE,YAAA;AAdF;;AAiBA,+BAAA;AACA;EACE,aAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,qCAAA;EACA,yBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,kCAAA;EACA,mBAAA;AAdF;AAgBE;EACE,uCAAA;AAdJ;AAiBE;EACE,kCAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,QAAA;EACA,yBAAA;AAhBF;;AAmBA;;EAEE,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,yBAAA;AAhBF;;AAmBA;EACE,6BAAA;EACA,2CAAA;EACA,kCAAA;AAhBF;AAkBE;EACE,4CAAA;EACA,uCAAA;EACA,yBAAA;AAhBJ;;AAoBA;EACE,sCAAA;EACA,YAAA;EACA,yBAAA;AAjBF;AAmBE;EACE,4CAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,mBAAA;AAlBJ","sourcesContent":["@import \"mixins\";\n.dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.dropdownTrigger {\n  padding: 10px 12px;\n  width: 100%;\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  background-color: var(--color-white);\n  color: var(--color-black);\n  font: var(--typography-body-m-regular);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 48px;\n\n  &:hover {\n    border-color: var(--color-strokes-blue);\n    background-color: white;\n  }\n}\n\n.dropdownValue {\n  flex: 1;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 8px;\n}\n\n.dropdownPlaceholder {\n  color: var(--color-text-secondary);\n}\n\n.dropdownArrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n\n  img {\n    width: 24px;\n    height: 24px;\n    transition: transform 0.2s ease;\n  }\n}\n\n.dropdownOpen .dropdownArrow img {\n  transform: rotate(180deg);\n}\n\n.dropdownList {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  max-height: 350px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.searchContainer {\n  padding: 8px;\n  border-bottom: 1px solid var(--color-gray-strokes);\n}\n\n.searchInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 8px;\n  font: var(--typography-body-m-regular);\n  outline: none;\n  transition: border-color 0.2s ease;\n\n  &:focus {\n    border-color: var(--color-strokes-blue);\n  }\n\n  &::placeholder {\n    color: var(--color-text-secondary);\n  }\n}\n\n.optionsList {\n  overflow-y: auto;\n  max-height: 280px;\n  padding: 4px;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--color-gray-strokes);\n    border-radius: 4px;\n\n    &:hover {\n      background: var(--color-text-secondary);\n    }\n  }\n}\n\n.dropdownOption {\n  padding: 10px 12px;\n  width: 100%;\n  min-height: 44px;\n  border: none;\n  border-radius: 8px;\n  background-color: var(--color-white);\n  color: var(--color-black);\n  font: var(--typography-body-m-regular);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  outline: none;\n\n  &:hover {\n    background-color: var(--color-bg-light-blue);\n  }\n\n  &.dropdownOptionSelected {\n    background-color: var(--color-blue-light);\n    color: var(--color-black);\n  }\n}\n\n.otherOption {\n  border-top: 1px solid var(--color-gray-strokes);\n  margin-top: 4px;\n  padding-top: 12px;\n  color: var(--color-text-secondary);\n  font-style: italic;\n\n  &:hover {\n    color: var(--color-black);\n  }\n}\n\n.loadingState,\n.emptyState,\n.hintState {\n  padding: 16px;\n  text-align: center;\n  color: var(--color-text-secondary);\n  font: var(--typography-body-s-regular);\n}\n\n.dropdownError .dropdownTrigger {\n  border-color: var(--color-error);\n\n  &:hover,\n  &:focus {\n    background-color: var(--color-white);\n    border-color: var(--color-error);\n    box-shadow: 0 0 0 3px rgba(206, 32, 33, 0.1);\n  }\n}\n\n.dropdownDisabled .dropdownTrigger {\n  background-color: #f5f5f5;\n  color: #999;\n  border-color: #e0e0e0;\n  cursor: not-allowed;\n  opacity: 0.6;\n\n  &:hover,\n  &:focus {\n    background-color: #f5f5f5;\n    border-color: #e0e0e0;\n    box-shadow: none;\n  }\n}\n\n.dropdownDisabled .dropdownArrow img {\n  opacity: 0.5;\n}\n\n/* Custom school input styles */\n.customInputContainer {\n  padding: 16px;\n}\n\n.customInputLabel {\n  margin: 0 0 12px 0;\n  font: var(--typography-body-m-medium);\n  color: var(--color-black);\n}\n\n.customInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 8px;\n  font: var(--typography-body-m-regular);\n  outline: none;\n  transition: border-color 0.2s ease;\n  margin-bottom: 12px;\n\n  &:focus {\n    border-color: var(--color-strokes-blue);\n  }\n\n  &::placeholder {\n    color: var(--color-text-secondary);\n  }\n}\n\n.customInputActions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.customInputCancel,\n.customInputSubmit {\n  padding: 8px 16px;\n  border-radius: 8px;\n  font: var(--typography-body-s-medium);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.customInputCancel {\n  background-color: transparent;\n  border: 1px solid var(--color-gray-strokes);\n  color: var(--color-text-secondary);\n\n  &:hover {\n    background-color: var(--color-bg-light-blue);\n    border-color: var(--color-strokes-blue);\n    color: var(--color-black);\n  }\n}\n\n.customInputSubmit {\n  background-color: var(--color-primary);\n  border: none;\n  color: var(--color-white);\n\n  &:hover:not(:disabled) {\n    background-color: var(--color-primary-hover);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `styles_dropdown__kyreG`,
	"dropdownTrigger": `styles_dropdownTrigger__zEYAQ`,
	"dropdownValue": `styles_dropdownValue__BStsP`,
	"dropdownPlaceholder": `styles_dropdownPlaceholder__L7dUQ`,
	"dropdownArrow": `styles_dropdownArrow__H6pZO`,
	"dropdownOpen": `styles_dropdownOpen__+IB4j`,
	"dropdownList": `styles_dropdownList__wvX1f`,
	"searchContainer": `styles_searchContainer__dqaI9`,
	"searchInput": `styles_searchInput__qOSbX`,
	"optionsList": `styles_optionsList__cLUQ+`,
	"dropdownOption": `styles_dropdownOption__yE3tS`,
	"dropdownOptionSelected": `styles_dropdownOptionSelected__tOwhE`,
	"otherOption": `styles_otherOption__t2xjN`,
	"loadingState": `styles_loadingState__YfsB8`,
	"emptyState": `styles_emptyState__Kl+4R`,
	"hintState": `styles_hintState__K69Qo`,
	"dropdownError": `styles_dropdownError__kfLj1`,
	"dropdownDisabled": `styles_dropdownDisabled__+XtSp`,
	"customInputContainer": `styles_customInputContainer__93DRC`,
	"customInputLabel": `styles_customInputLabel__2jg3z`,
	"customInput": `styles_customInput__IJS2q`,
	"customInputActions": `styles_customInputActions__jE21A`,
	"customInputCancel": `styles_customInputCancel__agMTA`,
	"customInputSubmit": `styles_customInputSubmit__dcL54`
};
export default ___CSS_LOADER_EXPORT___;
